import { render, staticRenderFns } from "./ResourcesSummary.vue?vue&type=template&id=236e10c2&scoped=true&"
import script from "./ResourcesSummary.vue?vue&type=script&lang=js&"
export * from "./ResourcesSummary.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesSummary.vue?vue&type=style&index=0&id=236e10c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e10c2",
  null
  
)

export default component.exports